module.exports = __webpack_public_path__ + "static/IMG_4437.1593b848.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/IMG_4437.png
// module id = 438
// module chunks = 168707334958949